import { useEffect, useMemo } from 'react';
import { useIntl } from 'react-intl';

import AuthenticationStore from '~/auth/authenticationStore';
import { FlagType } from '~/flags/flags';
import { useFlag } from '~/flags/useFlag';
import { useTrackSegment } from '~/hooks/useTrackSegment ';
import { api } from '~/redux/api/createApi';

export const useGetWorkdayUpcApps = () => {
  const AS = AuthenticationStore();
  const enableAppSwitcher = useFlag(FlagType.UniversalNavHeader);
  const intl = useIntl();
  const trackSegment = useTrackSegment();

  const persistedIsWorkdayUser = AS.getIsWorkdayUser();

  const { data: isWorkdayUser = persistedIsWorkdayUser ?? false } =
    api.endpoints.getIsWorkdayUser.useQuery({}, { skip: !enableAppSwitcher });

  const { data: apps, isError } = api.endpoints.getWorkdayUpcApps.useQuery(
    {},
    { skip: !enableAppSwitcher },
  );

  const appsError = useMemo(() => {
    if (isError) {
      return [
        {
          href: '',
          id: 'workday-upc-apps-error',
          isCurrentApplication: true, // sets disabled state
          label: intl.formatMessage({
            id: 'WorkdayUpcApps.error',
            defaultMessage:
              'Failed to retrieve applications. Refresh the page to try again.',
            description:
              'Error message displayed when fetching Workday UPC apps fails',
          }),
        },
      ];
    }
  }, [isError]);

  useEffect(() => {
    if (isWorkdayUser) {
      AS.setIsWorkdayUser(true);
    } else {
      AS.deleteIsWorkdayUser();
    }
    if (apps || isError) {
      // Track requests to Calypso from Pilot
      trackSegment('Fetch Workday UPC apps from Calypso', {});
    }
  }, [apps, isError, isWorkdayUser]);

  return { apps: isError ? appsError : apps, isWorkdayUser };
};
